import { LocalisationStation } from "../Shared/localisation-station";
import { MesureStation } from "./mesure-station";
import { Substrat } from "./substrat";
import { Transect } from "./transect";

export class MGCEProcess {
    Code: string;

    // RecouvrementZoneBerge: number;
    // RecouvrementZIAccessible: number;
    // RecouvrementZINonAccessible: number;
    // RecouvrementZoneProfonde: number;

    LocalisationStation: LocalisationStation = new LocalisationStation();
    MGCEMesureStation: MesureStation = new MesureStation();
    MGCESubstratList: Substrat[] = [];
    MGCETransectList: Transect[] = [];

    static mapFromJSON(json): MGCEProcess {
        const p = new MGCEProcess();

        p.Code = json.code;
        // p.RecouvrementZIAccessible = json.recouvrementZIAccessible;
        // p.RecouvrementZINonAccessible = json.recouvrementZINonAccessible;
        // p.RecouvrementZoneBerge = json.recouvrementZoneBerge;
        // p.RecouvrementZoneProfonde = json.recouvrementZoneProfonde;

        if (json.localisationStation)
            p.LocalisationStation = LocalisationStation.mapFromJSON(json.localisationStation);
        if (json.mgceMesureStation)
            p.MGCEMesureStation = MesureStation.mapFromJSON(json.mgceMesureStation);
        if (json.mgceSubstratList)
            p.MGCESubstratList = json.mgceSubstratList.map(jsonItem => Substrat.mapFromJSON(jsonItem));
        if (json.mgceTransectList) {
            p.MGCETransectList = json.mgceTransectList.map(jsonItem => Transect.mapFromJSON(jsonItem));
        }
        
        return p;
    }
}